import React from "react";
import Button from "../button/button";

const ArrowLeft = props => {
	return (
		<Button
			onClick={e => props.onClick(e)}
			className={`btn-gray-sm-icon offers-arrow-left ${props.className}`}
			data-action="arrow-left"
		>
			<i className="icon-arrow-down" />
		</Button>
	);
};

export default ArrowLeft;
